import type { Doc } from "building-types/doc";
import type { SolidFloorAssemblyOverride } from "building-types/floors/floorAssemblyTypes";
import type { FloorSystemHandle } from "building-types/handles/docEntityHandleTypes";
import { sortEntitiesBySortIndex } from "common/utils/sortIndex";
import { isSolidFloorAssemblyOverride } from "./elements/floor/floorAssembly";

export function docGetSolidFloorSystemFloors(
  floors: Doc["floors"],
  { id: floorSystemId }: FloorSystemHandle,
): SolidFloorAssemblyOverride[] {
  const solidFloors = Object.values(floors).filter(isSolidFloorAssemblyOverride);
  const floorSystemFloors = solidFloors.filter((x) => x?.parentId === floorSystemId);
  return sortEntitiesBySortIndex(floorSystemFloors);
}

export function docGetSolidFloorSystemFloorIdsFromFloorTable(
  floors: Doc["floors"],
  { id: floorSystemId }: FloorSystemHandle,
): string[] {
  const floorSystemFloors = docGetSolidFloorSystemFloors(floors, { id: floorSystemId, type: "FLOOR_SYSTEM" });
  return floorSystemFloors.map((x) => x.id);
}
